import { useEffect } from 'react';
import { brand } from '../config/brand';

export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} - ${brand.appName}` : brand.appName;
    return () => {
      document.title = brand.appName;
    };
  }, [title]);
}
